module.exports = __webpack_public_path__ + "img/peninsular-header.ecaa4cb5.png";